import { render, staticRenderFns } from "./profileScreenToTab.vue?vue&type=template&id=32e829bf&scoped=true&"
import script from "./profileScreenToTab.vue?vue&type=script&lang=js&"
export * from "./profileScreenToTab.vue?vue&type=script&lang=js&"
import style0 from "./profileScreenToTab.vue?vue&type=style&index=0&id=32e829bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e829bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e829bf')) {
      api.createRecord('32e829bf', component.options)
    } else {
      api.reload('32e829bf', component.options)
    }
    module.hot.accept("./profileScreenToTab.vue?vue&type=template&id=32e829bf&scoped=true&", function () {
      api.rerender('32e829bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profileScreenToTab.vue"
export default component.exports